import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMoon } from 'react-icons/fi';
import './Navbar.css';

const DEFAULT_MINIMAL_HOME = 'https://www.astralmoonmagic.com';

/**
 * @param {object} props
 * @param {boolean} [props.minimal] - Page-specific minimal bar: brand home + page title only
 * @param {string} [props.pageTitle] - Shown next to brand when minimal
 * @param {string} [props.homeHref] - External home URL (default marketing site)
 */
const Navbar = ({ user, onLogout, minimal, pageTitle, homeHref = DEFAULT_MINIMAL_HOME }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (onLogout) {
      await onLogout();
    }
    navigate('/login');
  };

  if (minimal) {
    const safeHome = homeHref || DEFAULT_MINIMAL_HOME;
    return (
      <nav className="navbar navbar--minimal" aria-label="Site">
        <div className="navbar-container navbar-container--minimal">
          <div className="navbar-minimal-inner">
            <a
              href={safeHome}
              className="navbar-logo navbar-logo--minimal-home"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FiMoon className="moon-icon" aria-hidden />
              <span className="navbar-brand-text">Astral Moon Magic</span>
            </a>
            {pageTitle ? (
              <>
                <span className="navbar-minimal-divider" aria-hidden />
                <span className="navbar-page-title">{pageTitle}</span>
              </>
            ) : null}
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-logo">
          <FiMoon className="moon-icon" />
          <span>Astral Moon</span>
        </Link>

        <div className="navbar-menu">
          <Link to="/dashboard" className="navbar-link">Dashboard</Link>
          <Link to="/birth-data" className="navbar-link">Syntymätiedot</Link>
          <Link to="/charts" className="navbar-link">Kartat</Link>
          <Link to="/files" className="navbar-link">Tiedostot</Link>
          <Link to="/runes" className="navbar-link">Riimut</Link>
          <Link to="/tarot" className="navbar-link">Tarot</Link>
          <Link to="/horoscope" className="navbar-link">Horoskoopit</Link>
          <Link to="/astrology-chart" className="navbar-link">Syntymäkartta</Link>
          <Link to="/chart" className="navbar-link">Birth Chart</Link>
          <Link to="/courses" className="navbar-link">Kurssit</Link>
          <Link to="/witch" className="navbar-link">Noitaprofiili</Link>
          {user ? (
            <button type="button" onClick={handleLogout} className="navbar-link btn-logout">
              Kirjaudu ulos
            </button>
          ) : (
            <Link to="/login" className="navbar-link">Kirjaudu</Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
